import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByStayDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData;
};

export const useReservationListByStayDateQueryData = () => {
	/**
	 * QueryData へ変換
	 */
	const onConvertQueryData = useCallback(
		({ serverData }: Props): Result => ({
			queryData: {
				reservationList: serverData?.reservationListByStayDate.reservations ?? [],
			},
		}),
		[],
	);

	return {
		onConvertQueryData,
	};
};
